// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-categories-table-row {\n    width: 100%;\n    display: grid;\n    grid-template-columns: auto 80px;\n    color: #626262;\n    border-bottom: 1px solid #F2F2F2;\n}\n.custom-head-row {\n    font-weight: bold;\n}\n.custom-data-row {\n    /*cursor: pointer;*/\n}\n.custom-data-row:hover {\n    background: #E9E9E9;\n}\n.custom-categories-table-label {\n    display: flex;\n    align-items: center;\n    padding: 8px;\n}\n.central-data {\n    justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
